import type { FC } from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";

import { UTBMS_ACTIVITIES } from "../model";

type Props = {
  value?: string | null;
  onChange: (code: string) => void;
  disabled?: boolean;
  className?: string;
};

/** The UTBMS activity code (A101–A111). */
export const CodeSelect: FC<Props> = ({
  value,
  onChange,
  disabled,
  className = "w-56"
}) => (
  <Select
    value={value ?? undefined}
    onValueChange={onChange}
    disabled={disabled}
  >
    <SelectTrigger
      size="sm"
      className={className}
      onClick={(e) => e.stopPropagation()}
      aria-label="Activity code"
    >
      <SelectValue placeholder="Activity code" />
    </SelectTrigger>
    <SelectContent>
      {UTBMS_ACTIVITIES.map((a) => (
        <SelectItem key={a.code} value={a.code}>
          <span className="font-mono text-sm text-fg-3">{a.code}</span>{" "}
          {a.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
